import React from 'react';
import {
  LoadFlex,
  LoadCardContainer,
  LoadRowContainer,
  LoadTitle,
} from './components';
import './styleLoader.css';

export const LoadNextUp = () => {
  return (
    <>
      <LoadTitle className="skeleton" />
      <LoadRowContainer>
        {[0, 1, 2].map((k) => (
          <LoadFlex key={k}>
            <LoadCardContainer className="skeleton" />
          </LoadFlex>
        ))}
      </LoadRowContainer>
    </>
  );
};
